module.exports = "/_next/static/images/da6f474cdfc94b92cb5be7d01022109b-hero-md.jpg.webp";